<template>
  <div class="w-full text-lg">
    <div v-if="error" class="error text-center">
      {{ error.message }}
    </div>
    <h1 class="page-header text-center text-3xl mx-0 mt-0">
      <slot name="title" />
    </h1>
    <div class="text-center my-2">
      <slot name="subtitle" />
    </div>
    <template v-if="range">
      <DateRange
        :start.sync="range.start"
        :end.sync="range.end"
        :max="range.max"
        :min="range.min"
        format="MM/dd/yyyy"
        @update:range="getReport(true)"
        class="w-56 mx-auto p-0 font-primary text-blue text-md mb-2"
      />
      <button
        class="button run block font-primary w-28 h-8 py-1 px-5 text-base text-white text-opacity-70 rounded-md"
        @click="getReport()"
      >
        run report
      </button>
    </template>
    <div class="download-wrapper flex justify-center items-center absolute top-2 right-5">
      <div v-if="downloadReportLoading" class="flex justify-center items-center w-40 mt-3">
        <loading-icon />
      </div>
      <template v-else-if="report">
        <button
          class="button block font-primary py-1 px-5 text-base h-8 text-white text-opacity-70 rounded-md"
          @click="generateExport"
        >
          download report
        </button>
      </template>
    </div>
    <template v-if="hasSearchInput">
      <input
        class="searchbox mt-12"
        type="text"
        placeholder="search"
        maxlength="100"
        @input="submitSearch"
      />
    </template>
  </div>
</template>

<script>
import { reportsAPI } from "../../services/api/reportsAPI";
import { DateRange, LoadingIcon } from '@springbig/sb-components';
import { debounce } from "lodash";

export default {
  props: {
    error: Object,
    hasSearchInput: Boolean,
    range: Object,
    report: Object
  },

  name: "ReportHeader",

  components: {
    DateRange,
    LoadingIcon
  },

  data(){
    return {
      downloadReportLoading: false
    }
  },

  methods: {
    submitSearch: debounce(function ($event){
      this.$emit('update:searchText', false, $event.target.value);
    }, 500),
    async checkDownloadUrlStatus() {
      try {
        const { report } = await reportsAPI.getReportDownloadUrl(this.report.id);
        if (report.download_url) {
          this.downloadReportLoading = false;
          this.report.download_url = report.download_url;
          // Download file right after generation is done
          const link = document.createElement('a');
          link.href = report.download_url;
          link.download = true;
          link.click();
          link.remove();
        }
        else if(report.export_state === 'failed') {
          this.error.message = "report generation failed. please try again.";
          this.downloadReportLoading = false;
        }
        else {
          setTimeout(this.checkDownloadUrlStatus, 1000);
        }
      }
      catch(error) {
        this.error.message = "error, please refresh or contact support";
        this.downloadReportLoading = false;
      }
    },
    generateExport() {
      this.error.message = null;
      if (!this.report.download_url) {
        this.downloadReportLoading = true;
        reportsAPI.generateExportByReportId(this.report.id);
        setTimeout(this.checkDownloadUrlStatus, 1000);
      }
    },
    getReport(newReport = false) {
      if(this.range.start && this.range.end) {
        this.error.message = null;
        this.$emit('getReport', newReport);
      }
      else {
        this.error.message = 'please select a start and end date';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
body{
  .page-header {
    margin: 0;
  }
  .button.run {
    margin: auto;
  }
  .searchbox {
    width: 530px;
  }
  @media only screen and (max-width: 1100px) {
    .download-wrapper {
      position: static;
      margin-top: 0.5rem;
    }
  }
}
</style>
